// removed by extract-text-webpack-plugin
module.exports = {"main":"src-components-modules-SecuritySection-style----security-module---main---y3eDE textAlign-center paddingTopBottom-xl","wrap":"src-components-modules-SecuritySection-style----security-module---wrap---1vr8p pageWrap c-black textAlign-center pageWrap-l"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/SecuritySection/style/security.module.css
// module id = 741
// module chunks = 47877783677342 112587981740051